<template>
    <q-btn :outline="outline" :loading="loading" :flat="flat" :small="small" :dense="dense" :round="round"
           :rounded="rounded" :no-caps="noCaps" :size="size" :icon="icon" :icon-right="iconRight"
           :label="label"
           :type="type"
           :color="color"
           :disable="disable" @click="$emit('click', $event); if (to) $router.push(to)"
           :prevent-keyboard="preventKeyboard">
        <slot></slot>
            <slot name="loading" slot="loading"></slot>
    </q-btn>
</template>

<script>
    import {
        QBtn
    } from 'quasar-framework'

    export default {
        name: 'VButton',

        props: {
            label: String,
            outline: {
                type: Boolean,
                default: false
            },
            small: Boolean,
            dense: Boolean,
            flat: Boolean,
            round: Boolean,
            rounded: {
                type: Boolean,
                default: true
            },
            size: {
                type: String,
                default: 'md'
            },
            noCaps: Boolean,
            disable: Boolean,
            color: {
                type: String,
                default: 'primary'
            },
            icon: String,
            iconRight: String,
            type: {
                type: String,
                default: 'button'
            },
            loading: Boolean,
            to: [String, Object],
            preventKeyboard: Boolean
        },

        components: {
            QBtn
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VButton.vue